import { gql } from 'urql';
import { gqlClient } from '@/graphql/client.js';

const LIST_MANTENIMIENTOS = gql`
  query ListMantenimientosFlota($page: Int, $pageSize: Int, $filter: MantenimientoFlotaFilter) {
    mantenimientosFlota(page: $page, pageSize: $pageSize, filter: $filter) {
      totalCount
      page
      pageSize
      edges {
        node {
          id
          tenantId
          sucursalId
          unidad
          patente
          descripcion
          fechaProgramada
          fechaRealizada
          costoEstimado
          proveedor
          estado
          createdAt
          updatedAt
          deletedAt
        }
      }
    }
  }
`;

const GET_MANTENIMIENTO = gql`
  query GetMantenimientoFlota($id: ID!) {
    mantenimientoFlota(id: $id) {
      id
      tenantId
      sucursalId
      unidad
      patente
      descripcion
      fechaProgramada
      fechaRealizada
      costoEstimado
      proveedor
      estado
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

const CREATE_MANTENIMIENTO = gql`
  mutation CreateMantenimientoFlota($input: CreateMantenimientoFlotaInput!) {
    createMantenimientoFlota(input: $input) {
      id
      unidad
      patente
      descripcion
      fechaProgramada
      fechaRealizada
      costoEstimado
      proveedor
      estado
      sucursalId
    }
  }
`;

const UPDATE_MANTENIMIENTO = gql`
  mutation UpdateMantenimientoFlota($id: ID!, $input: UpdateMantenimientoFlotaInput!) {
    updateMantenimientoFlota(id: $id, input: $input) {
      id
      unidad
      patente
      descripcion
      fechaProgramada
      fechaRealizada
      costoEstimado
      proveedor
      estado
      sucursalId
    }
  }
`;

const DELETE_MANTENIMIENTO = gql`
  mutation DeleteMantenimientoFlota($id: ID!) {
    deleteMantenimientoFlotaSoft(id: $id)
  }
`;

async function handleResult(result, fallbackMessage) {
  if (result.error) {
    throw new Error(result.error.message || fallbackMessage);
  }
  return result.data;
}

export async function fetchMantenimientosFlota({ page = 1, pageSize = 10, filter }, client = gqlClient) {
  const result = await client
    .query(LIST_MANTENIMIENTOS, { page, pageSize, filter })
    .toPromise();
  const data = await handleResult(result, 'No se pudo obtener el listado de mantenimientos.');
  return data?.mantenimientosFlota;
}

export async function fetchMantenimientoFlota(id, client = gqlClient) {
  const result = await client.query(GET_MANTENIMIENTO, { id }).toPromise();
  const data = await handleResult(result, 'No se pudo obtener el mantenimiento.');
  return data?.mantenimientoFlota;
}

export async function createMantenimientoFlota(input, client = gqlClient) {
  const result = await client.mutation(CREATE_MANTENIMIENTO, { input }).toPromise();
  const data = await handleResult(result, 'No se pudo crear el mantenimiento.');
  return data?.createMantenimientoFlota;
}

export async function updateMantenimientoFlota(id, input, client = gqlClient) {
  const result = await client.mutation(UPDATE_MANTENIMIENTO, { id, input }).toPromise();
  const data = await handleResult(result, 'No se pudo actualizar el mantenimiento.');
  return data?.updateMantenimientoFlota;
}

export async function deleteMantenimientoFlota(id, client = gqlClient) {
  const result = await client.mutation(DELETE_MANTENIMIENTO, { id }).toPromise();
  const data = await handleResult(result, 'No se pudo eliminar el mantenimiento.');
  return data?.deleteMantenimientoFlotaSoft;
}
